import { Component, OnInit, Inject } from '@angular/core';
import { ServiciosService } from 'app/services/servicios.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { EquiposComponent } from 'app/components/servicio-medico/despacho/subdespacho/equipos/equipos.component';

@Component({
  selector: 'app-agregar-enfermero',
  templateUrl: './agregar-enfermero.component.html',
  styleUrls: ['./agregar-enfermero.component.scss']
})
export class AgregarEnfermeroComponent implements OnInit {

    public auxiliar;
    public auxiliares;

  constructor(private servicios:ServiciosService,
              public dialogRef: MatDialogRef<EquiposComponent>,
              @Inject(MAT_DIALOG_DATA) private datos,
              private snack: MatSnackBar) { }

  ngOnInit() {
      this.servicios.auxiliar().subscribe((data)=>{
            this.auxiliares = data;
      })
  }

  enviar(){
    if (this.auxiliar == null || this.auxiliar == undefined || this.auxiliar == "" ) {
      this.snack.open('Elija un auxiliar', '', {
          duration: 2000,
          panelClass: 'red-bg'
        })
    } else {
      this.servicios.agregarAuxiliar(this.auxiliar.Cod_Aux, this.datos.movil).subscribe((data)=>{
          console.log(data);
      });
      this.dialogRef.close(this.auxiliar.Auxiliar);
    }
  }

}
